import { connect } from 'react-redux';

import Stepper from '../../components/Stepper';

const mapStateToProps = (state) => {
  function checkInformationStatuses() {
    let done = true;

    // forms
    if (
      done &&
      state.status.member1 !== 'APPROVED' &&
      state.status.member1 !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.application.showMember2 &&
      state.status.member2 !== 'APPROVED' &&
      state.status.member2 !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.status.apartment1 !== 'APPROVED' &&
      state.status.apartment1 !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.application.showApartment2 &&
      state.status.apartment2 !== 'APPROVED' &&
      state.status.apartment2 !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.status.swapReason !== 'APPROVED' &&
      state.status.swapReason !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.status.details1 !== 'APPROVED' &&
      state.status.details1 !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.application.showApartment2 &&
      state.status.details2 !== 'APPROVED' &&
      state.status.details2 !== 'UPDATED'
    )
      done = false;

    // documents
    if (
      done &&
      state.status.minUc !== 'APPROVED' &&
      state.status.minUc !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.status.proofOfId !== 'APPROVED' &&
      state.status.proofOfId !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.status.incomeBase !== 'APPROVED' &&
      state.status.incomeBase !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.status.rentalAgreement !== 'APPROVED' &&
      state.status.rentalAgreement !== 'UPDATED'
    )
      done = false;
    if (
      done &&
      state.status.rentalBase !== 'APPROVED' &&
      state.status.rentalBase !== 'UPDATED'
    )
      done = false;

    return done;
  }

  return {
    applicants: state.application.application.applicants,
    statuses: state.status.statuses,
    location: state.router.location,
    LBControlReady: state.status.LBControl === 'APPROVED',
    signReady: state.status.sign === 'APPROVED',
    landlordControlReady: state.status.landlordControl === 'APPROVED',
    collectInformationReady: checkInformationStatuses(),
  };
};

export default connect(mapStateToProps)(Stepper);



// WEBPACK FOOTER //
// ./src/features/Stepper/index.js